import React from "react";
import Button from "@mui/material/Button";
import { makeStyles } from "tss-react/mui";
import * as PropTypes from "prop-types";

export const Intent = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
};

const useStyles = makeStyles()((theme) => ({
  button: {
    margin: "0 5px",
    minWidth: "140px",
    maxWidth: "300px",
  },

  primaryButton: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },

  secondaryButton: {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },

  tertiaryButton: {
    background: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
  },

  successButton: {
    background: theme.palette.success.dark,
    color: theme.palette.primary.contrastText,
  },

  warningButton: {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },

  errorButton: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

interface IntentButtonProps {
  className?: string;
  intent?: string;
  startIcon?: React.ReactElement | null;
  [key: string]: any;
}

export default function IntentButton({
  className = "",
  intent = "",
  startIcon = null,
  ...props
}: IntentButtonProps) {
  const { classes, cx } = useStyles();
  const color: "inherit" | "primary" | "secondary" =
    intent === Intent.PRIMARY
      ? "primary"
      : intent === Intent.SECONDARY
      ? "secondary"
      : "inherit";

  const buttonClassName = cx(classes.button, className, {
    [classes.primaryButton]: intent === Intent.PRIMARY,
    [classes.secondaryButton]: intent === Intent.SECONDARY,
    [classes.tertiaryButton]: intent === Intent.TERTIARY,
    [classes.successButton]: intent === Intent.SUCCESS,
    [classes.warningButton]: intent === Intent.WARNING,
    [classes.errorButton]: intent === Intent.ERROR,
  });

  return (
    <Button
      color={color}
      {...props}
      className={buttonClassName}
      startIcon={startIcon}
    />
  );
}
